/* Manuals hub filtering + manual page table of contents. */
(function () {
  'use strict';

  function initHub(hub) {
    if (hub.dataset.kkManualsReady === 'true') return;
    hub.dataset.kkManualsReady = 'true';

    var input = hub.querySelector('[data-manuals-search]');
    var grid = hub.querySelector('[data-manuals-grid]');
    var empty = hub.querySelector('[data-manuals-empty]');
    var chips = Array.prototype.slice.call(hub.querySelectorAll('[data-manuals-filter]'));
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-manual-card]'));
    var activeFilter = 'all';

    function normalise(value) {
      return (value || '')
        .toLowerCase()
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss');
    }

    cards.forEach(function (card) {
      card.dataset.haystack = normalise(card.dataset.keywords);
    });

    function apply() {
      var terms = normalise(input ? input.value : '').split(/\s+/).filter(Boolean);
      var visible = 0;

      cards.forEach(function (card) {
        var matchesFilter = activeFilter === 'all' || card.dataset.category === activeFilter;
        var haystack = card.dataset.haystack;
        var matchesTerms = terms.every(function (term) {
          return haystack.indexOf(term) !== -1;
        });
        var show = matchesFilter && matchesTerms;
        card.hidden = !show;
        if (show) visible++;
      });

      if (empty) empty.hidden = visible !== 0;
    }

    if (input) {
      input.addEventListener('input', apply);
      input.addEventListener('search', apply);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeFilter = chip.dataset.manualsFilter;
        chips.forEach(function (other) {
          other.classList.toggle('is-active', other === chip);
        });
        apply();
      });
    });

    apply();
  }

  function initToc(body) {
    if (body.dataset.kkTocReady === 'true') return;
    body.dataset.kkTocReady = 'true';

    var links = Array.prototype.slice.call(body.querySelectorAll('[data-toc-link]'));
    var sections = Array.prototype.slice.call(body.querySelectorAll('[data-manual-section]'));
    if (!links.length || !sections.length || !('IntersectionObserver' in window)) return;

    var byAnchor = {};
    links.forEach(function (link) {
      byAnchor[link.dataset.tocLink] = link;
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var link = byAnchor[entry.target.dataset.anchor];
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach(function (other) {
              other.classList.remove('is-current');
            });
            link.classList.add('is-current');
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function initFaq(container) {
    if (container.dataset.kkFaqReady === 'true') return;
    container.dataset.kkFaqReady = 'true';

    // Rich text arrives as a flat run of headings and paragraphs.
    // Fold each heading and the content beneath it into a native disclosure,
    // so the accordion still works with JavaScript disabled.
    var nodes = Array.prototype.slice.call(container.children);
    var groups = [];
    var current = null;

    nodes.forEach(function (node) {
      if (/^H[2-4]$/.test(node.tagName)) {
        current = { heading: node, content: [] };
        groups.push(current);
      } else if (current) {
        current.content.push(node);
      }
    });

    if (!groups.length) return;

    groups.forEach(function (group) {
      var details = document.createElement('details');
      details.className = 'manual-faq__item';

      var summary = document.createElement('summary');
      summary.className = 'manual-faq__question';
      summary.textContent = group.heading.textContent;
      details.appendChild(summary);

      var answer = document.createElement('div');
      answer.className = 'manual-faq__answer';
      group.content.forEach(function (node) {
        answer.appendChild(node);
      });
      details.appendChild(answer);

      container.insertBefore(details, group.heading);
      container.removeChild(group.heading);
    });

    container.classList.add('manual-faq__list--ready');
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-manuals-hub]').forEach(initHub);
    scope.querySelectorAll('[data-manual-body]').forEach(initToc);
    scope.querySelectorAll('[data-manual-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
